import LessonPageStatus from 'components/lessons/LessonPageStatus';
import React from 'react';
import { ResourcesPageResult } from './resourcesHelpers';

type Props = {
  result: Exclude<ResourcesPageResult<unknown>, { subject: unknown }>;
};

/** A resource bank page while it loads, or when it is not found or fails to load */
const ResourcePageStatus: React.FC<Props> = ({ result }) => <LessonPageStatus status={result} />;

export default ResourcePageStatus;
